export const checkOverflowWidth = el => el.clientWidth < el.scrollWidth

export const onHover = ({ mouseenter, mouseleave }) => {
  const onEnter = e => {
    if (!checkOverflowWidth(e.target)) {
      return {}
    }
    return mouseenter(e)
  }
  return {
    mouseenter: onEnter,
    mouseleave
  }
}
